import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab';
import React from 'react';
import ImageToolsContainer from './imageToolsContainer';

const ImageToolsPanel = (props) => {
  const tabItems: ITabItem[] = [
    {
      content: <ImageToolsContainer />,
    },
  ];
  return (
    <div id="imagetoolspanel-wrapper">
      <BaseSidePanel tabItems={tabItems} headerTitle={'Image Tools'} />
    </div>
  );
};

export default ImageToolsPanel;
